import React from 'react';
import './BuiltForNDE.css';

const BRAND_GRAD = 'linear-gradient(90deg,#6366F1,#8B5CF6 55%,#D946EF)';

function BuiltForNDE() {
  return (
    <section style={{ background: '#180C2E', padding: '96px 56px' }}>
      <div className="oc-reveal" style={{ maxWidth: 1180, margin: '0 auto', display: 'grid', gridTemplateColumns: 'auto 1fr', gap: 48, alignItems: 'center' }}>
        <div style={{ width: 120, height: 120, borderRadius: 24, background: 'rgba(99,102,241,0.10)', border: '1px solid rgba(129,107,255,0.30)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <i className="bx bx-shield-quarter" style={{ fontSize: 56, background: BRAND_GRAD, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }} />
        </div>
        <div>
          <span style={{ font: '700 12px Manrope,sans-serif', letterSpacing: '0.16em', color: '#816BFF' }}>BUILT FOR NDT &amp; NDE</span>
          <h2 style={{ margin: '14px 0 0', fontFamily: 'Montserrat,sans-serif', fontWeight: 800, fontSize: 32, lineHeight: 1.25, letterSpacing: '-0.015em', color: '#fff' }}>AI document extraction for NDT.</h2>
          <p style={{ margin: '18px 0 0', maxWidth: 840, fontFamily: 'Montserrat,sans-serif', fontSize: 18, lineHeight: 1.65, color: 'rgba(255,255,255,0.70)' }}>
            Oculo is a proprietary AI extraction engine, purpose-built for the dense reports and records the NDT and NDE industry produces. It reads each document, extracts every field accurately, and structures the result into a clean, traceable record. It is not built for one contractor. Oculo works across the reports of every service company you receive.
          </p>
        </div>
      </div>
    </section>
  );
}

export default BuiltForNDE;
